import { type AxiosInstance } from "axios";

import { type UploadPLESRequest } from "./types";

const baseURL = "/v1/amazon-web-services/ples";

export const uploadPLEsHandler = async ({ api, req }: { api: AxiosInstance; req: UploadPLESRequest }) => {
  await api.postForm(baseURL, req);
};
